import User from '@/models/user';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setInStorage } from '@/services/storage';

interface UserState {
    profile: User | null;
}

const initialState: UserState = {
    profile: null,
};

export const user = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setProfile: (state, action: PayloadAction<User>) => {
            state.profile = action.payload;
            setInStorage('user', state.profile);
        },
    },
});

export const { setProfile } = user.actions;

export default user.reducer;
